import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'th' ? 'en' : 'th';
        i18n.changeLanguage(newLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full hover:bg-gray-100 transition-colors duration-200"
            aria-label="Switch Language"
        >
            <Globe size={18} className="text-gray-600" />
            <span className="text-sm font-medium text-gray-700 uppercase">
                {i18n.language || 'th'}
            </span>
        </button>
    );
};

export default LanguageSwitcher;
